/* eslint-disable import/no-anonymous-default-export */
const initialState = {
    isAuthenticated: false,
    token: '',
    _id: '',
    user_id: '',
    isAdmin: false,
    isClient: false,
    allowed_services: [],
    firstName: '',
    lastName: '',
    fullName: '',
    email: '',
    role: '',
    image: '',
    clientAdministrator: [],
    waterPackageList: [],
    AdminIntenetList: [],
    AdminStoreList: [],
    countryList: [],
    campsList: [],
    clientCamps: {},
    coordinatorList: [],
    accountantList: [],
    posList: [],
    internetList: [],
    storeList: [],
    currency_code: 'AED',
    POSModal:false,
    CampModal:'',
    RechargeModal:'',
    PosDeviceCode:[],
    startDate: new Date().toISOString().split("T")[0],
    endDate: new Date().toISOString().split("T")[0],
    revenue_package_data: null,
    investor_actual_transactions: [],
    selectedCamp: null,
    selectedCampId: null,
    selectedCampName: null,
    selectedCampComplaints: [],
    selectedServiceId: null,
    selectedClientAdminId: null,
    selectedZone: null,
    selectedBuilding: null,
    selectedWaterStore: null,
    selectedClient: null,
    selectedUser: null,
    selectedComplaintId: null,
    selectedComplaint: null,
    isLandlord: true
};

export default function (state = initialState, action) {
    
    switch (action.type) {
        case 'AUTHENTICATE': {
            const data = { isAuthenticated: !!action.payload, allowed_services: [] }
            if (action.payload) {
                console.log("action.payload: ", action.payload);
                data.token = action?.payload?.token ? action?.payload?.token : localStorage.getItem('accessToken')
                data._id = action?.payload?.user_data?._id || action?.payload?.user_data?.id
                data.user_id = action?.payload?.user_data?.id || action?.payload?.user_data?._id
                data.firstName = action?.payload?.user_data?.firstName ? action?.payload?.user_data?.firstName : ''
                data.lastName = action?.payload?.user_data?.lastName ? action?.payload?.user_data?.lastName : ''
                data.email = action?.payload?.user_data?.email
                data.fullName = action?.payload?.user_data?.full_name ? action?.payload?.user_data?.full_name : action?.payload?.user_data?.name
                data.image = action?.payload?.profileImage ? action?.payload?.profileImage : ''
                data.role = action?.payload?.user_data?.slug || action?.payload?.user_data?.role_slug || ''
                data.isAdmin = action?.payload?.user_data?.isAdmin;
                data.isClient = action?.payload?.user_data?.isClient;
                data.allowed_services = Array.isArray(action?.payload?.user_data?.allowed_services)
                    ? action.payload.user_data.allowed_services
                    : [];
                data.isLandlord = action?.payload?.user_data?.is_landlord;
            }
            return { ...state, ...data, user_data: action?.payload?.user_data };
        }
        case 'CLIENTLIST': {
            return { ...state, clientAdministrator: action?.payload };
        }
        case 'WATERPACKGELIST': {
            return { ...state, waterPackageList: action?.payload };
        }
        case 'STORELIST': {
            return { ...state, AdminStoreList: action?.payload };
        }
        case 'ADMININTENETLIST': {
            return { ...state, AdminIntenetList: action?.payload };
        }
        case 'COUNTRYLIST': {
            return { ...state, countryList: action?.payload };
        }
        case 'CAMPSLIST': {
            return { ...state, campsList: action?.payload };
        }
        case 'CLIENT_CAMPS': {
            const { clientId, camps } = action?.payload || {};
            if (!clientId) return state;
            return {
                ...state,
                clientCamps: {
                    ...state.clientCamps,
                    [clientId]: camps || [],
                },
            };
        }
        case 'COORDINATORLIST': {
            return { ...state, coordinatorList: action?.payload };
        }
        case 'ACCOUNTANTLIST': {
            return { ...state, accountantList: action?.payload };
        }
        case 'POSLIST': {
            return { ...state, posList: action?.payload };
        }
        case 'INTERNETLIST': {
            return { ...state, internetList: action?.payload };
        }
        case 'ASSIGNPOS': {
            return { ...state, POSModal: action?.payload };
        }
        case 'ASSIGNCAMP': {
            return { ...state, CampModal: action?.payload };
        }
        case 'SEARCHUSER': {
            return { ...state, RechargeModal: action?.payload };
        }
        case 'POSDEVICECODE': {
            return { ...state, PosDeviceCode: action?.payload };
        }
        case 'START_DATE': {
            return { ...state, startDate: action?.payload };
        }
        case 'END_DATE': {
            return { ...state, endDate: action?.payload };
        }
        case 'VIEW_REVENUE_PACKAGES': {
            return { ...state, revenue_package_data: action?.payload };
        }
        case 'INVESTOR_ACTUAL_TRANSACTIONS': {
            return { ...state, investor_actual_transactions: action?.payload };
        }
        case 'SELECTED_CAMP': {
            return { ...state, selectedCamp: action?.payload };
        }
        case 'SELECTED_CAMP_ID': {
            return { ...state, selectedCampId: action?.payload };
        }
        case 'SELECTED_CAMP_NAME': {
            return { ...state, selectedCampName: action?.payload };
        }
        case 'SELECTED_CAMP_COMPLAINTS': {
            return { ...state, selectedCampComplaints: action?.payload };
        }
        case 'SELECTED_SERVICE_ID': {
            return { ...state, selectedServiceId: action?.payload };
        }
        case 'SELECTED_CLIENT_ADMIN_ID': {
            return { ...state, selectedClientAdminId: action?.payload };
        }
        case 'SELECTED_ZONE': {
            return { ...state, selectedZone: action?.payload };
        }
        case 'SELECTED_BUILDING': {
            return { ...state, selectedBuilding: action?.payload };
        }
        case 'SELECTED_WATER_STORE': {
            return { ...state, selectedWaterStore: action?.payload };
        }
        case 'SELECTED_CLIENT': {
            return { ...state, selectedClient: action?.payload };
        }
        case 'SELECTED_USER': {
            return { ...state, selectedUser: action?.payload };
        }
        case 'SELECTED_COMPLAINT_ID': {
            return { ...state, selectedComplaintId: action?.payload };
        }
        case 'SELECTED_COMPLAINT': {
            return { ...state, selectedComplaint: action?.payload };
        }
        default:
            return state;
    }

}
